import { Grid } from "@material-ui/core";
import { SVG, Text } from "sunrise-ui";
import "./Reports.scss";

const SteelCard = (props: any) => {

    const { data } = props;

    return (
        <Grid container xs={12}>
            <Grid style={{ width: '12rem' }} className={"box--shadow p1 mr-1 steel-card"}>
                <Grid item xs={12} className="mt">
                    <Text
                        type="normal"
                        fonts="normal"
                        fontSize={18}
                        className="card-text mb1 mt0 fw400"
                    >
                        <span className="box--shadow p">{data.title}</span>
                    </Text>
                </Grid>

                <Grid className="d-flex v-center f18 w100">
                    <Grid className="mr">
                        <SVG type={"received"} />
                    </Grid>
                    <span>Received:</span>
                    <span className="ms1 float-right fw500">{data.received}</span>
                </Grid>

                <Grid className="d-flex v-center f18 w100">
                    <Grid className="mr">
                        <SVG type={"consumed"} />
                    </Grid>
                    <span>Consumed:</span>
                    <span className="ms1 float-right fw500">{data.consumed}</span>
                </Grid>

                <Grid className="d-flex v-center f18 w100">
                    <Grid className="mr">
                        <SVG type={"inStock"} />
                    </Grid>
                    <span>In Stock:</span>
                    <span className="ms1 float-right fw500">{data.inStock}</span>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default SteelCard;